// extracted by mini-css-extract-plugin
module.exports = {"PlugIt":"it_PlugIt__dPcKQ"};